import { useMemo } from 'react';

import { countCorrectionChanges } from '../talentReviewCorrection';

type CorrectionPlacement = Parameters<typeof countCorrectionChanges>[0][number];

/**
 * People whose placement differs from the submitted review while a superuser
 * is correcting a snapshot. Zero when not correcting.
 * @param correcting whether a superuser is correcting a snapshot
 * @param before placements on the submitted review
 * @param after placements on the current grid
 */
const useTalentReviewCorrectionChanges = (
	correcting: boolean,
	before: readonly CorrectionPlacement[],
	after: readonly CorrectionPlacement[],
) =>
	useMemo(
		() => (correcting ? countCorrectionChanges(before, after) : 0),
		[after, before, correcting],
	);

export default useTalentReviewCorrectionChanges;
